import React, { Component } from "react";
import { Row, Col, Icon, Menu } from 'antd';
import { getDeviceStatus } from "../../action/device_status.action";
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import { urls } from '../../helper/backend.urls'
import { historyMP } from '../../helper/history';
import { globalUrlPrefix } from '../../utils/const'

export class ScannerInfoCard extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.dispatch(getDeviceStatus(this.props.id));
    }

    render() {
        var status = Object.is(this.props.deviceStatus, undefined) ? false : (this.props.deviceStatus.scanner_health || {}).scanner_response != undefined;

        var cloneProps = Object.assign({}, this.props);

        delete cloneProps.isFetching;
        delete cloneProps.deviceStatus;
        delete cloneProps.deviceList;
        delete cloneProps.dispatch;

        return (
            <Menu.Item key={"scanner-" + this.props.id} {...cloneProps}>
                <Link to={urls.current + `/` + globalUrlPrefix + `/scanners/${this.props.id}/`}>
                   <Icon type="camera" />
                    <span>{this.props.name}</span>
                </Link>
            </Menu.Item>
        )
    }
}

const mapStateToPropsScannerInfo = (state, ownProps) => {
    return {
        isFetching: state.deviceAlert.isFetching,
        deviceStatus: state.deviceStatusReducer[ownProps.id]
    }
}

export default connect(mapStateToPropsScannerInfo)(ScannerInfoCard);